import React from 'react';
import DevPortfolioEtech from './DevPortfolioEtech';
import './index.css'; // Tailwind importé ici

function App() {
  return (
    <div>
      <DevPortfolioEtech />
    </div>
  );
}

export default App;
